export default __webpack_public_path__ + "static/media/nodepay.479ea5fc.png";